"use strict";

exports.__esModule = true;
exports.Bar = void 0;
var _react = _interopRequireDefault(require("react"));
var _useUiDesign2 = require("../../../Theme/UiDesign/useUiDesign");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Bar = exports.Bar = function Bar(props) {
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var x = props.x,
    height = props.height,
    yScale = props.yScale,
    barWidth = props.barWidth,
    value = props.value,
    color = props.color;
  var topY = function topY(value) {
    return yScale(value);
  };
  var barHeight = function barHeight(value) {
    return height - topY(value) < 0 ? 1 : height - topY(value);
  };
  return /*#__PURE__*/_react["default"].createElement("rect", {
    x: x,
    y: topY(value),
    rx: modern ? 3 : undefined,
    fill: color || "inherit",
    width: barWidth,
    height: barHeight(value)
  });
};